import MyAddresses from 'components/MyAddresses';
import MyAddressesHOC from 'HOC/myAddressesHOC';

export default MyAddressesHOC(MyAddresses);
